export default "<mat-form-field>\r\n  <input matInput name=\"oldcode\" placeholder=\"Old code\" [(ngModel)]=\"model.oldCode\" />\r\n</mat-form-field>\r\n"